import React, { useState } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { Trash } from '@withjoy/joykit/icons';
import { DragIcon } from '@assets/icons';
import { useSortableItemContext } from '@shared/components/SortableList/context/SortableItem.context';
import { FaqItemWithId } from '../Faq.types';
import { useTranslation } from '@shared/core';

interface FaqItemProps {
  item: FaqItemWithId;
  onEdit: () => void;
  onDelete: () => void;
}

export const FaqItem: React.FC<FaqItemProps> = ({ item, onEdit, onDelete }) => {
  const { tq } = useTranslation('faqCustomComponent');
  const [isHover, setIsHover] = useState(false);
  const { attributes, listeners, draggableNodeRef } = useSortableItemContext();

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      backgroundColor="white"
      borderRadius={4}
      padding={4}
      gap={3}
      cursor="pointer"
      onClick={onEdit}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      _hover={{ backgroundColor: 'mono2' }}
      position="relative"
    >
      {/* Drag Handle */}
      <Flex
        visibility={isHover ? 'visible' : 'hidden'}
        cursor="grab"
        {...attributes}
        {...listeners}
        ref={draggableNodeRef}
        onClick={e => e.stopPropagation()}
      >
        <DragIcon />
      </Flex>

      {/* Content */}
      <Flex
        flexDirection="column"
        gap={1}
        flex={1}
      >
        <TextV2
          typographyVariant="body2"
          fontWeight="bold"
          color="mono14"
        >
          {item.title || tq`Untitled`}
        </TextV2>
        <TextV2
          typographyVariant="body3"
          color="mono10"
        >
          {item.subtitle || tq`No answer`}
        </TextV2>
      </Flex>

      {/* Delete Button */}
      {isHover && (
        <Flex
          as="button"
          onClick={handleDelete}
          border="2px solid"
          borderColor="mono3"
          borderRadius="50%"
          width={32}
          height={32}
          alignItems="center"
          justifyContent="center"
          backgroundColor="white"
          color="mono14"
          _hover={{ color: 'negative5' }}
          _active={{ color: 'negative7' }}
        >
          <Trash size={16} />
        </Flex>
      )}
    </Flex>
  );
};
